export default {
  setInternshipState ({ commit }, payload) {
    commit('SET_INTERNSHIP_STATE', payload);
  },

  resetInternshipState ({ commit }) {
    commit('RESET_INTERNSHIP_STATE');
  },

  addTrackingData ({ commit }, payload) {
    commit('ADD_TRACKING_DATA', payload);
  },

  resetTrackingData ({ commit }) {
    commit('RESET_TRACKING_DATA');
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js